export default function(v) {
    return v != null ? (Array.isArray(v) ? v : [v]) : [];
}
